(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("canvas"));
	else if(typeof define === 'function' && define.amd)
		define(["canvas"], factory);
	else if(typeof exports === 'object')
		exports["imui"] = factory(require("canvas"));
	else
		root["imui"] = factory(root["canvas"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__517__) => {
return 